{
  "CreateAccount": {
    "mainHeader": "你好",
    "invitation": "{{invitedBy}} 已邀请您加入此工作区"
  },
  "RegisterUserPanel": {
    "header": "创建账户",
    "emailLabel": "电子邮件",
    "passwordLabel": "输入密码",
    "passwordPlaceholder": "确保其安全",
    "confirmPasswordLabel": "确认您的密码",
    "confirmPasswordPlaceholder": "输入密码",
    "continueButton": "继续",
    "errors": {
      "passwordRequired": "密码为必填项",
      "passwordMinLength": "密码必须至少8个字符",
      "passwordUpperCase": "您的密码应至少包含1个大写字母",
      "confirmPasswordRequired": "请确认您的密码",
      "passwordsMismatch": "密码不匹配"
    }
  },
  "CreateProfile": {
    "header": "关于你",
    "subheader": "告诉我们一些关于你的信息以便开始"
  },
  "CreateProfilePanel": {
    "header": "创建个人档案",
    "firstNameLabel": "名字",
    "firstNamePlaceholder": "名字",
    "lastNameLabel": "姓氏",
    "lastNamePlaceholder": "姓氏",
    "continueButton": "继续",
    "errors": {
      "firstNameRequired": "名字为必填项",
      "lastNameRequired": "姓氏为必填项"
    }
  },
  "CompletedRegistration": {
    "headerWithName": "{{firstName}}，您的帐户已设置完毕！",
    "header": "您的帐户已设置完毕！",
    "description": "来自Atellio的诚挚问候。我们是一家人才管理平台，助力企业自主管理其人才网络",
    "letsGo": "带我去那里"
  },
  "ArrivalBoard": {
    "scheduleBoard": "日程板",
    "page": "页面",
    "name": "姓名",
    "location": "地点",
    "role": "职位"
  }
}
